import { Directive, ElementRef, HostBinding } from '@angular/core'

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input:not([maxlength)',
  standalone: false,
})
export class InputLengthConstraintDirective {
  @HostBinding('attr.maxlength') get length() {
    return 80
  }
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'textarea:not([maxlength])',
  standalone: false,
})
export class TextareaLengthConstraintDirective {
  @HostBinding('attr.maxlength') get length() {
    return 8000
  }
}
